import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Select,
  Col,
  DatePicker,
  Button,
  Icon,
  TreeSelect
} from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
import './Header.less';

export default function TableHeader(props) {
  const { filters, updateFilter, clearFilters, reloadData } = props;

  const renderFilters = () => {
    return filters.map(
      ({ label, placeholder, key, type, data, defaultValue, values }) => {
        return (
          <Col span={6} key={key}>
            {type === 'input' && (
              <Input
                onChange={val => updateFilter(key, val)}
                placeholder={placeholder || label}
              />
            )}
            {type === 'boolean' && (
              <Select
                autoClearSearchValue={true}
                mode="tags"
                size="default"
                placeholder={placeholder || label}
                className="filter-box"
                onChange={val => updateFilter(key, val)}
                defaultValue={defaultValue}
              >
                <Option key="active">Active</Option>
                <Option key="inactive">Inactive</Option>
              </Select>
            )}
            {type === 'select' && (
              <Select
                autoClearSearchValue={true}
                mode="tags"
                size="default"
                value={values}
                placeholder={placeholder || label}
                className="filter-box"
                onChange={val => updateFilter(key, val)}
              >
                {data &&
                  data.map(d =>
                    d && d.value ? (
                      <Option key={d.value}>{d.label}</Option>
                    ) : (
                      <Option key={d}>{d}</Option>
                    )
                  )}
              </Select>
            )}
            {type === 'date' && (
              <RangePicker
                placeholder={[label + ' Start Date', label + ' End Date']}
                format={dateFormat}
                value={values}
                className="filter-box"
                onChange={val => updateFilter(key, val)}
              />
            )}
            {type === 'tree' && (
              <TreeSelect
                showSearch
                style={{ width: '100%' }}
                value={values}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="Please select"
                allowClear
                multiple
                treeNodeFilterProp="title"
                treeData={data}
                treeDefaultExpandAll={false}
                onChange={val => {
                  updateFilter(key, val);
                }}
              />
            )}
          </Col>
        );
      }
    );
  };
  return (
    <Row type="flex" gutter={16} className="table-header">
      {renderFilters()}
      <Col span={6}>
        <Row type="flex" className="btns">
          <Button onClick={clearFilters} type="danger">
            <Icon type="close-circle" />
            Clear Filters
          </Button>
          <Button onClick={reloadData} type="primary">
            <Icon type="reload" />
            Refresh
          </Button>
        </Row>
      </Col>
    </Row>
  );
}
TableHeader.propTypes = {
  filters: PropTypes.array,
  values: PropTypes.array,
  updateFilter: PropTypes.func,
  clearFilters: PropTypes.func,
  reloadData: PropTypes.func
};

TableHeader.defaultProps = {
  filters: [
    {
      label: 'Label',
      placeholder: 'Placeholder',
      key: 'key',
      type: 'select',
      data: [],
      values: []
    }
  ]
};
